<template>
  <div class="indexContainner" >
    <!-- <dv-full-screen-container style="width: 100%; height: 100%;"> -->
    <div class="globalContainner">
      <div class="contain" :class="isLq =='lq'?'lqS':'swS'">
        <el-container style="height:100%">
          <el-header>
            <el-row style="height:100%">
              <el-col :span="9">
                <el-col :span="15" class="header-1">
                  <el-select
                    :popper-append-to-body="false"
                    popper-class="select-E"
                    v-model="engineeringVal"
                    @change="changeEngineer"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in engineeringList"
                      :key="item.id"
                      :label="item.engineeringName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="9" class="header-2">
                  <el-select
                    :popper-append-to-body="false"
                    popper-class="select-S"
                    v-model="sectionVal"
                    @change="changeSection"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in sectionList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-col>
              <el-col :span="6" >
                <!-- <div class="middleStr">沥青路面施工综合展示系统</div> -->
              </el-col>
              <el-col :span="9">
                <el-col
                  :span="7"
                  class="header-3"
                  :class="isLq == 'lq' ? 'lqLight' : 'lqDark'"
                >
                  <div @click="selectType('lq')" class="type-writing">
                    沥青面层
                  </div>
                </el-col>
                <el-col
                  :span="7"
                >
                  <div class="type-writing">

                  </div>
                </el-col>
                <el-col :span="5" class="header-5">
                  <img
                    src="../assets/img/title-icon-time@2x.png"
                    alt=""
                    class="littleLogo"
                  />
                  <div class="writingCon">
                    <div class="big-writing">{{ currentDate }}</div>
                    <div class="small-writing">{{ currentTime }}</div>
                  </div>
                </el-col>
                <el-col :span="5" class="header-5">
                  <img :src="weatherLogo" alt="" class="littleLogo" />
                  <div class="writingCon">
                    <div class="big-writing">
                      {{ temperatureLower }}
                      <!-- {{ temperatureLower+'~'+temperatureUp }} -->
                       <span>°C</span>
                    </div>

                    <div class="small-writing">{{ weatherSynopsis }}</div>
                  </div>
                </el-col>
                <!-- <el-col :span="5" class="header-5 header-back">
                  <button
                    type="button"
                    class="back-screen-btn"
                    :class="{ 'is-group': fromGroup }"
                    @click="handleBackToPlatform"
                  >
                    <svg
                      class="back-screen-btn__icon"
                      width="7"
                      height="10"
                      viewBox="0 0 7 10"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M5.5 1L1.5 5L5.5 9"
                        stroke="#9BFFF6"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.2 1L2.2 5L6.2 9"
                        stroke="#9BFFF6"
                        stroke-opacity="0.45"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="back-screen-btn__text">{{ backBtnText }}</span>
                  </button>
                </el-col> -->
              </el-col>
            </el-row>
          </el-header>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
        <videoBox></videoBox>
        <frontVideoCloud></frontVideoCloud>
      </div>
    <!-- </dv-full-screen-container> -->
    </div>
    <a href='https://beian.miit.gov.cn/' target='_blank' style='cursor: pointer;color: #fff;position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);z-index: 999;'>苏ICP备11019701号</a>
  </div>
</template>

<script>
var cookie = {
	set:function(key,val,time){//设置cookie方法
		var date=new Date(); //获取当前时间
		var expiresDays=time;  //将date设置为n天以后的时间
		date.setTime(date.getTime()+expiresDays*24*3600*1000); //格式化为cookie识别的时间
		document.cookie=key + "=" + val +";expires="+date.toGMTString();  //设置cookie
	},
	get:function(key){//获取cookie方法
		/*获取cookie参数*/
		var getCookie = document.cookie.replace(/[ ]/g,"");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
		var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
		var tips;  //声明变量tips
		for(var i=0;i<arrCookie.length;i++){   //使用for循环查找cookie中的tips变量
			var arr=arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
			if(key==arr[0]){  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
				tips=arr[1];   //将cookie的值赋给变量tips
				break;   //终止for循环遍历
			}
		}
		return tips;
	}
}
import { mapState } from "vuex";
import videoBox from '../subassembly/video'
import frontVideoCloud from '../subassembly/frontVideoCloud'
import {
  loginSystem,
  getListEngineer,
  getListSection,
  getListWorkArea,
  getSectionDetail,
  getWeather,
  getInitScreenData,
  getListWorkAreaE
} from "@/api/api";

/** 路面质控集团大屏 */
const GROUP_BIG_SCREEN_URL = 'https://henan-kxjc.jsti-smart.cn/bigScreen'
/** 非集团入口时「返回」落点（监控台） */
const PLATFORM_HOME_URL = 'https://henan-kxjc.jsti-smart.cn/#/monitor'

export default {
   components: {
        videoBox,
        frontVideoCloud
    },
  data() {
    return {
      currentTime: "",
      currentDate: "",
      weatherSynopsis: "",
      temperatureLower: "",
      temperatureUp:"",
      isLq: "lq",
      weatherLogo: require("../assets/img/title-iconweather@2x.png"),
      engineeringList: [],
      sectionList: [],
      engineeringVal: "",
      units: {
        introduction: "",
        Participation: "",
        construction: "",
        supervisor: "",
        Design: ""
      },
      sectionVal: "",
      sess:"",
      /** 外链 hash 携带的工程 / 工区（工区列表项 id），用后即清 */
      pendingHashEngineerId: '',
      pendingHashWorkAreaId: '',
      /** 是否从集团大屏跳转而来 */
      fromGroup: false
    };
  },
  created() {},
  mounted() {
     var that = this ;
    setInterval(() => {
      this.NumberFix();
    }, 1000);
    this.login();
  },
  methods: {
    // 获取温度风速
    async getTW(workId) {
      let req = {
        engineeringConfigId:workId
      };
      const ertData = await getInitScreenData(req);
      console.log(ertData)
      console.log(workId)
      if (ertData.status == 200) {
        console.log(ertData)
        const env = (ertData.data && ertData.data.resultData) || {}
        this.temperatureLower = Number(env.envTemperature || 0).toFixed(0)
      }
    },
    parseHashQuery() {
      const hash = window.location.hash || ''
      const q = hash.indexOf('?')
      if (q === -1) return {}
      const out = {}
      hash.slice(q + 1).split('&').forEach(pair => {
        const eq = pair.indexOf('=')
        if (eq === -1) return
        const key = decodeURIComponent(pair.slice(0, eq))
        const val = decodeURIComponent(pair.slice(eq + 1) || '')
        out[key] = val
      })
      return out
    },
    async login() {
      console.log(window.location.hash.split("?")[0].split('/')[1])
      if(window.location.hash.split("?")[0].split('/')[1] == 'swLayer') {
        this.isLq = 'sw'
      }else {
        this.isLq = 'lq'
      }
      const params = this.parseHashQuery()
      if (params.pz != null && params.pz !== '') {
        this.userName = params.pz
        sessionStorage.setItem('userName', params.pz)
      }
      if (params.qm != null && params.qm !== '') {
        this.password = params.qm
        sessionStorage.setItem('password', params.qm)
      }
      if (params['Access-Token']) {
        sessionStorage.setItem('Access-Token', params['Access-Token'])
      }
      // 集团大屏带 from=group；监控台等外链不带该参数
      if (Object.prototype.hasOwnProperty.call(params, 'from')) {
        this.fromGroup = params.from === 'group'
        if (params.from) {
          sessionStorage.setItem('jumpFrom', params.from)
        } else {
          sessionStorage.removeItem('jumpFrom')
        }
      } else if (params['Access-Token'] || params.engineerId || params.workAreaId) {
        this.fromGroup = false
        sessionStorage.removeItem('jumpFrom')
      } else {
        this.fromGroup = sessionStorage.getItem('jumpFrom') === 'group'
      }
      const engFromHash = params.engineerId
      this.pendingHashEngineerId = engFromHash != null && String(engFromHash).trim() !== '' ? String(engFromHash).trim() : ''
      const waFromHash = params.workAreaId
      this.pendingHashWorkAreaId = waFromHash != null && String(waFromHash).trim() !== '' ? String(waFromHash).trim() : ''

      const storedToken = sessionStorage.getItem('Access-Token')
      if (storedToken) {
        await this.getEngineer()
        return
      }

      let un = sessionStorage.getItem('userName')
      let pw = sessionStorage.getItem('password')
      let req = {
        username: un,
        password: pw
      }
      await loginSystem(req)
      this.getEngineer()
    },
    // 获取工程
    async getEngineer() {
      const engData = await getListEngineer();
      if (engData.status == 200) {
        this.engineeringList = engData.data || [];
        const list = this.engineeringList
        let engId = list.length ? list[0].id : ''
        const hintEng = this.pendingHashEngineerId
        if (hintEng !== '' && list.length) {
          const hit = list.find(e => String(e.id) === hintEng)
          if (hit) engId = hit.id
        }
        this.pendingHashEngineerId = ''
        this.engineeringVal = engId
        this.$store.commit("updataEngineerId", this.engineeringVal);
        const curEngForSso = list.find(e => String(e.id) === String(this.engineeringVal)) || list[0]
        this.$store.commit(
          "updataEngineerSsoId",
          curEngForSso && curEngForSso.ssoId != null && curEngForSso.ssoId !== '' ? curEngForSso.ssoId : ''
        );
        await this.getSection();
        this.getWeather();
        const curEng = list.find(e => String(e.id) === String(this.engineeringVal)) || list[0]
        if (curEng) {
          this.units = {
            introduction: curEng.engingeeringIntro,
            Participation: curEng.constructionCompany.name
          };
        }
      }
      this.$store.commit("updataIntroduction", this.units.introduction);
      this.$store.commit("updataParticipation", this.units.Participation);

    },
    // 获取工程下标段
    // async getSection() {
    //   this.sectionList = [];
    //   this.sectionVal = "";
    //   let req = {
    //     engId: this.engineeringVal,
    //     mType: this.isLq
    //   };
    //   const secData = await getListSection(req);
    //   this.sectionList = secData.data;
    //   this.sectionVal = secData.data.length > 0 ? secData.data[0].id : "";
    //   this.$store.commit("updataSectionId", this.sectionVal);
    //   sessionStorage.setItem("sectionName", secData.data.length > 0?secData.data[0].sectionName:'');
    //   this.SectionDetail(this.sectionVal);
    //   this.getWorkArea()
    // },
    // 根据工程查工区
    async getSection() {
      this.sectionList = [];
      this.sectionVal = "";
      let req = {
        engId: this.engineeringVal,
        mType:this.isLq
      };
      const secData = await getListWorkAreaE(req);
      console.log(secData)
      this.sectionList = secData.data || [];
      const rows = this.sectionList
      const hintWa = this.pendingHashWorkAreaId
      if (!rows.length) {
        this.sectionVal = "";
        this.sess = "";
        this.pendingHashWorkAreaId = ''
        this.$store.commit("updataSectionSsoId", "");
        return
      }
      let row = null
      if (hintWa !== '') {
        row = rows.find(item => String(item.id) === hintWa)
      }
      if (!row) row = rows[0]
      this.pendingHashWorkAreaId = ''
      this.sectionVal = row.id
      this.applySectionRow(row)
      // this.getWorkArea()
    },
    applySectionRow(row) {
      if (!row) return
      this.sess = row.section ? row.section.id : ''
      this.$store.commit(
        "updataSectionSsoId",
        row.section && row.section.ssoId != null && row.section.ssoId !== '' ? row.section.ssoId : ''
      );
      this.$store.commit("updataSeIds", this.sess);
      this.$store.commit("updataSectionId", row.id);
      this.$store.commit("updataWorkAreaId", row.section ? row.section.id : '');
      const sectionName =
        (row.sectionName != null && row.sectionName !== '')
          ? row.sectionName
          : (row.section && row.section.sectionName) || ''
      sessionStorage.setItem("sectionName", sectionName);
      this.SectionDetail(this.sess);
      this.getTW(row.id)
    },
    // 获取工区
    async getWorkArea() {
      let req = {
        sectionId: this.sectionVal,
        workAreaType:this.isLq
      };
      const waData = await getListWorkArea(req);
      if(waData.data.length>0) {
        // this.getTW(waData.data[0].id)
        // this.$store.commit("updataWorkAreaId", waData.data[0].id);
      }else {
        // this.$store.commit("updataWorkAreaId", '');
      }
      // sessionStorage.setItem("workAreaId", waData.data[0].id);
    },
    async SectionDetail(id) {
      if (id == "") {
      } else {
        let req = {
          sectionId: id
        };
        const sdData = await getSectionDetail(req);

        this.units = {
          construction: sdData.data.constructionOfficeList[0]
            ? sdData.data.constructionOfficeList[0].name
            : "",
          supervisor: sdData.data.controlOfficeList[0]
            ? sdData.data.controlOfficeList[0].name
            : "",
          Design: sdData.data.designOfficeList[0]
            ? sdData.data.designOfficeList[0].name
            : ""
        };
        this.$store.commit("updataConstruction", this.units.construction);
        this.$store.commit("updataSupervisor", this.units.supervisor);
        this.$store.commit("updataDesign", this.units.Design);
      }
    },
    // 获取天气信息
    async getWeather() {
      let req = {
        engineeringId: this.engineeringVal
      };
      const weaData = await getWeather(req);
      console.log(weaData)
      // this.temperatureLower = weaData.data.tem2;
      // this.temperatureUp = weaData.data.tem1;
      this.weatherSynopsis = weaData.data.stateDetailed?weaData.data.stateDetailed:"";
      if(this.weatherSynopsis.indexOf('晴') >= 0) {
        this.weatherLogo = require("../assets/img/title-iconweather@2x.png")
      }else if(this.weatherSynopsis.indexOf('雷') >= 0) {

      }else if(this.weatherSynopsis.indexOf('雨') >= 0) {

      }else if(this.weatherSynopsis.indexOf('雪') >= 0) {

      }else {

      }
    },
    // 获取当前时间
    NumberFix() {
      const val = new Date();
      const y = val.getFullYear();
      const m = (val.getMonth() + 1).toString().padStart(2, "0");
      const d = val
        .getDate()
        .toString()
        .padStart(2, "0");
      const h = val
        .getHours()
        .toString()
        .padStart(2, "0");
      const mi = val
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const s = val
        .getSeconds()
        .toString()
        .padStart(2, "0");
      this.currentTime = `${y}-${m}-${d}`;
      this.currentDate = `${h}:${mi}:${s}`;
      // 2020-05-19+10:11:00
    },
    async changeEngineer(val) {
      this.$store.commit("updataSectionSsoId", "");
      this.getWeather();
      this.getSection();
      // this.SectionDetail(this.sectionVal)
      this.$store.commit("updataEngineerId", val);
      this.engineeringList.forEach(item => {
        if (item.id == val) {
          this.$store.commit(
            "updataEngineerSsoId",
            item.ssoId != null && item.ssoId !== '' ? item.ssoId : ''
          );
          this.$store.commit("updataIntroduction", item.engingeeringIntro);
          this.$store.commit(
            "updataParticipation",
            item.constructionCompany.name
          );
        }
      });
    },
    changeSection(val) {
      const row = this.sectionList.find(item => String(item.id) === String(val))
      if (!row) return
      this.sectionVal = val
      this.applySectionRow(row)
    },
    // 类型切换
    selectType(type) {
      this.isLq = type;
      this.getSection();
      if (type == "lq") {
        this.$router.push({ path: "/lqLayer", query: { } });
      } else {
        this.$router.push({ name: "swLayer", params: { aa: "xx", bb: "xx" } });
      }
    },
    handleBackToPlatform() {
      if (this.fromGroup) {
        window.location.href = GROUP_BIG_SCREEN_URL
        return
      }
      // 监控台等入口多为新开标签，优先关闭；无法关闭时回平台首页
      window.close()
      setTimeout(() => {
        if (!window.closed) {
          window.location.href = PLATFORM_HOME_URL
        }
      }, 200)
    }
  },
  computed: {
    ...mapState([
      "engineerId",
      "sectionId",
      "introduction",
      "Participation",
      "construction",
      "supervisor",
      "Design"
    ]),
    backBtnText() {
      return this.fromGroup ? '返回集团平台' : '返回'
    }
  }
};
</script>
<style lang="less" scoped>
.lqS {
  background-image: url(../assets/img/lqBgNew.png);
  //background-image: url(../assets/img/bg55.jpg);//润程
}
.swS {
  // background-image: url(../assets/img/swBgNew.png);
  background-image: url(../assets/img/lqBgNew.png);
//background-image: url(../assets/img/bg33.jpg);//润程
}
.globalContainner {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  transform-origin: left top;
  z-index: 999;
}
.indexContainner {
  .contain {
    height: 100%;
    width: 100%;
    // background-image: url(../assets/img/bg33.jpg);
    background-size: 100% 100%;
  }
  .el-header {
    height: 65px !important;
    .el-row {
      .el-col-8,
      .el-col-9,
      .el-col-6,
      .el-col-15,
      .el-col-5,
      .el-col-7,
      .el-col-3,
      .el-col-2,
      .el-col-4 {
        height: 100%;
        margin-top: 10px;
      }
      .header-1 {
        background-size: 100% 80%;
        background-repeat: no-repeat;
        background-image: url(../assets/img/title-engineering@2x.png);
      }
      .header-2 {
        margin-left: -28px;
        background-size: 100% 80%;
        background-repeat: no-repeat;
        background-image: url(../assets/img/title-bidsection@2x.png);
      }
      .header-3 {
        margin-left: 28px;
        margin-right: -30px;
        background-size: 100% 80%;
        background-repeat: no-repeat;
      }
      .header-4 {
        background-size: 100% 80%;
        background-repeat: no-repeat;
      }
      .header-5 {
        .littleLogo {
          float: left;
          width: 20px;
          height: 20px;
          margin-top: 4px;
          margin-left: 20px;
        }
        .writingCon {
          float: left;
          margin-left: 6px;
          .big-writing {
            font-size: 22px;
            // font-family: Fantasy;
            color: #fff;
            span {
              font-family: Serif;
              font-size: 16px;
              font-weight: 600;
            }
          }
          .small-writing {
            font-size: 15px;
            font-family: Serif;
            color: #fff;
          }
        }
      }
      .header-back {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        padding-right: 8px;
        box-sizing: border-box;
      }
      .back-screen-btn {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 25px;
        min-width: 64px;
        padding: 0 12px 0 14px;
        margin-top: 6px;
        border: 1px solid #7af1fc;
        border-radius: 4px;
        background: linear-gradient(
          90deg,
          rgba(4, 92, 110, 0.16) 0%,
          rgba(0, 5, 20, 0) 100%
        );
        box-shadow:
          0 0 10px rgba(44, 126, 251, 0.31),
          inset 0 0 12.2px rgba(87, 196, 250, 0.35);
        color: #9bfff6;
        font-size: 15px;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-weight: 500;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        outline: none;
        transition: opacity 0.2s ease, box-shadow 0.2s ease;

        &.is-group {
          min-width: 129px;
        }

        &:hover {
          opacity: 0.92;
          box-shadow:
            0 0 12px rgba(44, 126, 251, 0.45),
            inset 0 0 12.2px rgba(87, 196, 250, 0.45);
        }
      }
      .back-screen-btn__icon {
        flex-shrink: 0;
        display: block;
      }
      .back-screen-btn__text {
        letter-spacing: 0.5px;
      }
      .type-writing {
        cursor: pointer;
        text-align: center;
        margin-left: 20px;
        line-height: 44px;
        height: 60%;
        font-size: 16px;
      }
    }
  }
  .lqLight {
    background-image: url(../assets/img/title-asphalt-select@2x.png);
    color: #fff721;
  }
  .lqDark {
    background-image: url(../assets/img/title-asphalt@2x.png);
    color: #fff;
  }
  .swLight {
    background-image: url(../assets/img/title-waterstability-select@2x.png);
    color: #fff721;
  }
  .swDark {
    background-image: url(../assets/img/title-waterstability@2x.png);
    color: #fff;
  }
  .el-main {
    padding: 20px;
    padding-top: 6px;
  }
}
</style>
<style lang="less">
.indexContainner {
  .el-col-15 {
    .el-select {
      width: 380px;
      margin-left: 30px;
    }
    .el-input {
      width: 360px !important;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-input--suffix .el-input__inner {
      // padding-right: 0.6rem;
      background: rgba(0, 0, 0, 0);
      color: #fff !important;
      border: none;
      width: 360px !important;
      // padding-bottom: 6px;
      // margin-left: 30px !important;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .el-col-9 {
    .el-select {
      width: 188px;
      margin-left: 25px;
    }
    .el-input {
      width: 190px;
      overflow: hidden;
      margin-left: 30px !important;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .el-input--suffix .el-input__inner {
      // padding-right: 0.6rem;
      background: rgba(0, 0, 0, 0);
      color: #fff !important;
      border: none;
      width: 190px;
      // padding-bottom: 6px;
      // margin-left: 30px;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  // .el-input__inner:nth-of-type(1) {
  //   margin-left: 32px;
  // }
  .el-select .el-input .el-select__caret {
    color: yellow;
  }
  .el-icon-arrow-up:before {
    content: "\e78f";
  }
}
.select-E {
  left: 42px !important;
  width: 400px !important;
  min-width: 10px !important;
}
.select-S {
  min-width: 10px !important;
  width: 256px !important;
  left: 452px !important;
}
.el-select-dropdown__item {
  color: #fff;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: rgba(7, 21, 68, 0.3);
}
.el-select-dropdown {
  background: rgba(7, 21, 68, 1);
  border: none;
}
.el-select-dropdown el-popper:nth-of-type(1) .el-select-dropdown {
  left: 100px !important;
}
.el-popper .popper__arrow::after {
  border-bottom-color: rgba(7, 21, 68, 0.3) !important;
}
.el-popper .popper__arrow {
  border-bottom-color: rgba(7, 21, 68, 0) !important;
}
.el-select-dropdown__item {
  width: 100% !important;
}
.middleStr {
  color:#fff;
  background-color: #0a1b4d;
  font-size: 40px;
  letter-spacing: 10;
  font-weight: 700;
  font-style: italic;
margin-left: 58px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue